var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "560"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "tit tit--xs"
  }, [_vm._v("송장정보")]), _c('v-card-text', [_c('v-select', {
    attrs: {
      "items": _vm.methods,
      "item-text": "text",
      "item-value": "value",
      "label": "배송방법",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    on: {
      "input": function input(value) {
        var _vm$setting;

        _vm.shippingInfo.invoiceNumber = null;
        _vm.shippingInfo.courier = value ? ((_vm$setting = _vm.setting) === null || _vm$setting === void 0 ? void 0 : _vm$setting.courierCode) || null : null;
      }
    },
    model: {
      value: _vm.shippingInfo.method,
      callback: function callback($$v) {
        _vm.$set(_vm.shippingInfo, "method", $$v);
      },
      expression: "shippingInfo.method"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "운송장번호",
      "persistent-placeholder": "",
      "hide-details": "",
      "disabled": _vm.shippingInfo.method != "\uD0DD\uBC30" && _vm.shippingInfo.method != "\uD035\uBC30\uC1A1"
    },
    model: {
      value: _vm.shippingInfo.invoiceNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.shippingInfo, "invoiceNumber", $$v);
      },
      expression: "shippingInfo.invoiceNumber"
    }
  }), _c('v-select', {
    staticClass: "mt-4",
    attrs: {
      "items": _vm.couriers,
      "item-text": "text",
      "item-value": "code",
      "label": "운송사",
      "persistent-placeholder": "",
      "hide-details": "",
      "disabled": _vm.shippingInfo.method != "\uD0DD\uBC30" && _vm.shippingInfo.method != "\uD035\uBC30\uC1A1"
    },
    model: {
      value: _vm.shippingInfo.courier,
      callback: function callback($$v) {
        _vm.$set(_vm.shippingInfo, "courier", $$v);
      },
      expression: "shippingInfo.courier"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "grey"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.input
    }
  }, [_vm._v("확인")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }